import React from 'react';
import {
  Placemark,
  WithYMapsProps,
  Map as YMap,
  withYMaps,
} from 'react-yandex-maps';

const markPosition = [56.832521067845654, 60.59009049999988];
const center = [56.83645804984439, 60.58863674643593];
const modules = ['templateLayoutFactory'];
const markHTML =
  '<img style="height: 80px; width: 88px; transform: translate(-50%, -73%);" src="/images/marker-map.svg"/>';
const defaultStateMap = {
  center,
  zoom: 14,
};

export const Map = withYMaps(
  // TODO: поправить типизацию
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ ymaps }: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    const mark = ymaps.templateLayoutFactory.createClass(markHTML, {});
    return (
      <YMap defaultState={defaultStateMap} height="100%" width="100%">
        <Placemark
          geometry={markPosition}
          options={{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            iconLayout: mark,
          }}
        />
      </YMap>
    );
  },
  true,
  modules,
);
